import { gql } from '@apollo/client';

export const FETCH_CREW_MEMBER = gql`
	query GetCrewMember($id: ID!) {
		getCrewMember(id: $id) {
			id
			fullName
			email
			drugTestExpiresAt
			isActive
			drugTestExpiresAt
			driverCard
			phone
			currentHomeBase {
				id
				effectiveTimestamp
				city {
					name
					timezone
				}
			}
			permanentHomeBase {
				id
				effectiveTimestamp
				city {
					name
				}
			}
			currentLocation {
				city {
					name
				}
				station {
					name
					code
				}
				fromTimestamp
			}
			lastWorkAssignment {
				fromTimestamp
				toTimestamp
				activity {
					fromStation {
						name
						code
					}
					toStation {
						name
						code
						city {
							name
						}
					}
				}
			}
			nextAvailability
			startTime
			endTime
			medicalCheckExpiresAt
			driverLicenseExpiresAt
			currentRun {
				id
				name
			}
			currentJobs {
				id
				code
			}
			hoursTracking {
				drivingMinutesBalance
				drivingMinutesLimit
				dutyMinutesBalance
				dutyMinutesLimit
				eightDaysDutyMinutesBalance
				eightDaysDutyMinutesLimit
			}
			holdDowns {
				id
				crewMember {
					id
					fullName
				}
				originalCrewMember {
					id
					fullName
					email
				}
				effectiveTimestamp
				expireTimestamp
				note
				createdAt
				updatedBy
			}
		}
	}
`;
